export * from '@taqueria/protocol/out/types/ParsedOperation';
